import { User, Mail, Lock, Phone, Briefcase, Eye, EyeOff } from 'lucide-react';
import { useState } from 'react';
import { Link,useNavigate } from 'react-router-dom';
import './auth.css';
import axios from 'axios';

export default function Register() {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
   
  });
   const navigate=useNavigate();

  const handlesubmit=async()=>{
    const response = await axios.post(`https://api.squareandangle.pranatigroup.in/api/authentication/authregister`,{
      name:formData.name, email:formData.email, password:formData.password,role:'admin'
    });
    localStorage.setItem('user', JSON.stringify(response.data.user));
    localStorage.setItem('userId', response.data.user?.id ?? '');
    localStorage.setItem('role', response.data.user?.role ?? 'admin');
    alert('Register Successfully');
    navigate('/admin/chat_ready');  
  }
 
  return (
    <div className="authPage">
      <div className="authShell" aria-label="Register page">
        <div className="authCard">
          <div className="authCardInner">
            <div className="authBrand">
              <div className="authLogo" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5z" />
                </svg>
              </div>
              <div className="authBrandText">
                
                <p>Pranati </p>
              </div>
            </div>

            <h2 className="authTitle">Create account</h2>
            <p className="authSubtitle">Fill in your details to get started.</p>

            <form className="authForm">
              <div className="authGrid2">
                <div>
                  <label className="authLabel" htmlFor="reg-first">Name</label>
                  <div className="authField">
                    <User className="authIconLeft" size={18} />
                    <input
                      id="reg-first"
                      className="authInput"
                      type="text"
                     
                      value={formData.name}
                     
                      placeholder="Name"
                      onChange={
                        (e)=>setFormData({...formData,name:e.target.value})
                      }
                    />
                     
                  </div>
                </div>

                <div>
                  <label className="authLabel" htmlFor="reg-last">Last Name</label>
                  <div className="authField">
                    <User className="authIconLeft" size={18} />
                    <input
                      id="reg-last"
                      className="authInput"
                      type="email"
                      
                      value={formData.email}

                      onChange={(e)=>setFormData({...formData,email:e.target.value})}
                     
                      placeholder="Email"
                    />
                  </div>
                </div>
              </div>

              <div className="authGrid2">
                <div>
                  <label className="authLabel" htmlFor="reg-email">Email Address</label>
                  <div className="authField">
                    <Mail className="authIconLeft" size={18} />
                    <input
                      id="reg-email"
                      className="authInput"
                      type="password"
                     
                      value={formData.password}

                      onChange={(e)=>setFormData({...formData,password:e.target.value})}
                      placeholder="password"
                    />
                  </div>
                </div>

              
              </div>

              
             
              <button type="button" className="authButton" onClick={handlesubmit}>
                Create Account
              </button>
               <Link to="/forgot-password" className="authLink">
                  Forgot password?
                </Link>

              <div className="authFooter">
                Already have an account?{' '}
                <Link to="/login" className="authLink">Log in</Link>
              </div>
            </form>
          </div>
        </div>

        <div className="authFinePrint">
          <div>© 2026 Pranati. All rights reserved.</div>
        </div>
      </div>
    </div>
  );
}
